import { render, staticRenderFns } from "./sendCard.vue?vue&type=template&id=0cbc2168&scoped=true&"
import script from "./sendCard.vue?vue&type=script&lang=js&"
export * from "./sendCard.vue?vue&type=script&lang=js&"
import style0 from "./sendCard.vue?vue&type=style&index=0&id=0cbc2168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc2168",
  null
  
)

export default component.exports